import * as ko from 'knockout';

import { BaseForm } from './base_form';
import * as clientTypesApi from '../api/client_types';
import { Deferred } from '../utils/deferred';
import { asI18nText } from '../i18n_text';
import { createWithComponent } from '../utils/ko_utils';
import { ClientType } from '../models/client_type';

let template = require('raw-loader!../../templates/client_type_edit.html').default;

class ClientTypeEditScreen extends BaseForm<clientTypesApi.ClientTypeData> {
  entity = ko.validatedObservable<ClientType>(null);

  constructor(
    params: {
      id: string;
      initialName?: string;
      result?: Deferred<clientTypesApi.ClientTypeData>;
    },
    componentInfo: KnockoutComponentTypes.ComponentInfo
  ) {
    super(params);

    let requestPromise = params.id ? clientTypesApi.retrieve(params.id) : undefined;
    let promise = Promise.all([requestPromise]).then(([data]) => {
      this.entity(new ClientType(data));
      if (!data && params.initialName) {
        this.entity().nameJson(asI18nText(params.initialName));
      }
    });
    this.loadedAfter(promise).then(() => this.focusFirst(componentInfo.element));
  }

  save = () => {
    if (this.validateLocal(this.entity)) {
      let data = this.entity().toData();
      this.executeSaveRequest(clientTypesApi.save(data)).then((validation) => {
        this.onRemoteValidation(data, this.entity(), validation);
      });
    }
  };
}

export let clientTypeEdit = {
  name: 'client-type-edit',
  viewModel: createWithComponent(ClientTypeEditScreen),
  template: template,
};

ko.components.register(clientTypeEdit.name, clientTypeEdit);
